import { AfterViewInit, Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'app-icons',
    templateUrl: './icons.component.html',
    styleUrls: ['./icons.component.scss'],
    standalone: false
})
export class IconsComponent implements AfterViewInit {

  @ViewChild('list')
  private listTemplate: TemplateRef<any> | undefined;

  @ViewChild('folder')
  private folderTemplate: TemplateRef<any> | undefined;

  @ViewChild('logout')
  private logoutTemplate: TemplateRef<any> | undefined;

  @ViewChild('cast')
  private castTemplate: TemplateRef<any> | undefined;

  @ViewChild('shoppingbag')
  private shoppingbagTemplate: TemplateRef<any> | undefined;

  @ViewChild('bell')
  private bellTemplate: TemplateRef<any> | undefined;

  @ViewChild('users')
  private usersTemplate: TemplateRef<any> | undefined;

  @ViewChild('info')
  private infoTemplate: TemplateRef<any> | undefined;

  @Input()
  public name: 'list' | 'folder' | 'logout' | 'cast' | 'shoppingbag' | 'bell' | 'users' | 'info' |  undefined;

  @Input()
  public width: number;

  @Input()
  public height: number;

  public viewIsInit = false;

  public constructor() {
    this.width = 14;
    this.height = 14;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.viewIsInit = true;
    });
  }

  public getCurrentTemplate(): TemplateRef<any> {
    return this[this.name + 'Template' as Extract<keyof this, string>] as TemplateRef<any>;
  }
}
